const marquee = (selector: HTMLElement | undefined, speed: number) => {
  if (!selector) {
    return;
  }

  const clone = selector.innerHTML;
  const firstElement = selector.children[0] as HTMLElement;

  let i = 0;

  selector.insertAdjacentHTML('beforeend', clone);
  selector.insertAdjacentHTML('beforeend', clone);

  setInterval(() => {
    firstElement.style.marginLeft = `-${i.toString()}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }

    i = i + speed;
  }, 5);
};

export const marqueePartners = () => {
  const loops = document.querySelectorAll('.js-partners-mobile, .js-partners-desktop');

  loops.forEach((loop) => {
    marquee(loop as HTMLElement, 0.3);
  });
};
